export enum Direction {
    PAY_IN = 'in',
    PAY_OUT = 'out',
}